module.exports = __webpack_public_path__ + "img/trash.519d02b5.svg";